
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.517 3.984l2.312-2.418a.516.516 0 000-.709L4.15.146a.467.467 0 00-.679 0L.141 3.629a.519.519 0 000 .711l3.361 3.513a.466.466 0 00.679 0l.679-.709a.517.517 0 000-.71l-2.343-2.45z"}}),_c('path',{attrs:{"d":"M9.859 6.434l-2.342-2.45 2.312-2.418a.516.516 0 000-.709L9.15.146a.467.467 0 00-.679 0l-3.33 3.483a.519.519 0 000 .711l3.361 3.513a.466.466 0 00.679 0l.679-.709a.518.518 0 00-.001-.71z"}})])
          )
        }
      }
    